class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, this.dataset.name,this.dataset.variantid);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
        freeGift(event,'add','');
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => {
              response.text();
        })
        .then((responseText) => {            
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
         const cartFooter = html.querySelector('.cart-drawer__footer');
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
         
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          console.log('sourceQty',  sourceQty);
          this.innerHTML = sourceQty.innerHTML;
         
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
         
        freeGift(parsedState,'update',variantId);

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML( parsedState.sections[section.section], section.selector );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
       
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    console.log('selector',selector)
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function freeGift(params,type,modifiedId) {
  let threshold = document.querySelector('cart-drawer').getAttribute('data-threshold');
  let varId = document.querySelector('cart-drawer').getAttribute('data-var-id');
  let prodId = document.querySelector('cart-drawer').getAttribute('data-product-id');

  let totalPrice = 0;
  let totalFree = 0;
  if(type == 'add'){
      let html = new DOMParser().parseFromString(params.cartData.sections['cart-drawer'], 'text/html');
      let total = html.querySelector('.totals__total-value').getAttribute('data-total');

      let cartCount = html.querySelector('cart-drawer').getAttribute('data-count');

      // console.log ("total",total);
      totalPrice = total ;

      let cartItems = html.querySelectorAll('.cart-item');
        cartItems.forEach(item => {
            // Check if the item has any data attributes
            for (let attr of item.attributes) {
                if (attr.name.startsWith('data-free')) {
                    totalFree = attr.value; 
                    return;
                }
            }
        });

        if (parseInt(totalPrice) >= parseInt(threshold)){   
           freeGiftAdd(totalFree,prodId,varId);
        }
        else {
          // console.log("remove function call");
          freeGiftRemove(varId,cartCount);
        }
  }
  else {
 
     console.log("total update", params.items);
     console.log('variant id above', varId);
     console.log("modified id", modifiedId);

     let total = params.total_price ;
     totalPrice = total ;
     let cartCount = params.items;
     let items = params.items;
     for (let i = 0; i < items.length; i++) {
          let item = items[i];
          // Check if the item's ID matches the product ID
          if (item.product_id == prodId) {
              // Store the matched item's ID in totalFree
              totalFree = item.product_id;
              // Exit the loop once a match is found
              break;
          }
      }
      console.log("totalFree",totalFree);
      if (parseInt(totalPrice) >= parseInt(threshold) && modifiedId != varId ){ 
      freeGiftAdd(totalFree,prodId,varId);
      }
      else {
        console.log("remove function call");
        freeGiftRemove(varId,cartCount);
      }
  }    
}

function freeGiftAdd(totalFree,prodId,varId) {
   console.log("totalFree",totalFree);
   console.log("prodId",prodId);
   console.log("varId",varId);

    if (totalFree != prodId) {   
 
            let formData = {
               'items': [{
                'id': parseInt(varId),
                'quantity': 1,
                'properties':  {
                  'Free': 'true'
                }
                }],
               'sections': 'cart-drawer,main-cart-items'
          };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
  
        .then(responseText => {
          console.log("response",responseText)
          const html = new DOMParser().parseFromString(responseText.sections['cart-drawer'], 'text/html');
          const cartItems = new DOMParser().parseFromString(responseText.sections['main-cart-items'], 'text/html');

          const cartItemsTargetEl = document.querySelector('#main-cart-items');       
          const cartItemsSourceEl = cartItems.querySelector('#main-cart-items');

          console.log("cartItems",cartItems)

          if (cartItemsTargetEl && cartItemsSourceEl) {
            if (cartItemsSourceEl instanceof HTMLElement) {
                cartItemsTargetEl.replaceWith(cartItemsSourceEl);
            } else {
                console.error(`Source element for selector "cart-items" is not an HTMLElement.`);
            }
          } else {
            if (!cartItemsSourceEl) {
                console.warn(`No element found in response for selector "cart-items".`);
            }
          }
          let cartCount = html.querySelector('cart-drawer').getAttribute('data-count')
          const selectors = ['cart-drawer-items', '.cart-drawer__footer', 'free-shipping'];
          for (const selector of selectors) {
              const targetElement = document.querySelector(selector);              
              const sourceElement = html.querySelector(selector);      
              console.log('Target Element: add', targetElement);      
              if (targetElement && sourceElement) {
                  if (sourceElement instanceof HTMLElement) {
                      targetElement.replaceWith(sourceElement);
                  } else {
                      console.error(`Source element for selector "${selector}" is not an HTMLElement.`);
                  }
              } else {
                  if (!sourceElement) {
                      console.warn(`No element found in response for selector "${selector}".`);
                  }
              }
          }

            const container = document.querySelector('.cart-count-bubble');
            if (container) {
                let spanElement = container.querySelector('span[aria-hidden=true]');

                if (!spanElement) {
                    spanElement = document.createElement('span');
                    spanElement.setAttribute('aria-hidden', 'true');
                    container.appendChild(spanElement);
                }
                spanElement.textContent = cartCount;
            } else {
                console.error('Container element not found.');
            }

            document.querySelector('.c-cart-template__shipping-container').innerHTML = shipping_modal_content;
            document.querySelector('.c-cart-template__shipping-container').innerHTML = cover_duties_modal_content;
      })
      .catch(error => {
          console.error('Error:', error);
      });
      
    
    }
}

function freeGiftRemove(varId,cartCount) {

  console.log("cartCount",cartCount);

  let updates = {
    [parseInt(varId)]: 0
  };
  
  console.log("update",updates);
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates: updates, sections: 'cart-drawer,main-cart-items' })
  })
  .then(response => {
    return response.json();
  })
  .then(responseText => {
        const html = new DOMParser().parseFromString(responseText.sections['cart-drawer'], 'text/html');
        const cartItems = new DOMParser().parseFromString(responseText.sections['main-cart-items'], 'text/html');
          const cartItemsTargetEl = document.querySelector('#main-cart-items');       
          const cartItemsSourceEl = cartItems.querySelector('#main-cart-items');
          if (cartItemsTargetEl && cartItemsSourceEl) {
            if (cartItemsSourceEl instanceof HTMLElement) {
                cartItemsTargetEl.replaceWith(cartItemsSourceEl);
            } else {
                console.error(`Source element for selector "cart-items" is not an HTMLElement.`);
            }
          } else {
            if (!cartItemsSourceEl) {
                console.warn(`No element found in response for selector "cart-items".`);
            }
          }
        let cartCount = html.querySelector('cart-drawer').getAttribute('data-count');
        const selectors = ['#CartDrawer'];
        const container = document.querySelector('.cart-count-bubble');
            if (container) {
                let spanElement = container.querySelector('span[aria-hidden=true]');

                if (!spanElement) {
                    spanElement = document.createElement('span');
                    spanElement.setAttribute('aria-hidden', 'true');
                    container.appendChild(spanElement);
                }
                spanElement.textContent = cartCount;
            } else {
                console.error('Container element not found.');
            }
        for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            console.log('Target Element remove:', targetElement);
            if (targetElement && sourceElement) {
                if (sourceElement instanceof HTMLElement) {
                    targetElement.replaceWith(sourceElement);
                } else {
                    console.error(`Source element for selector "${selector}" is not an HTMLElement.`);
                }
            } else {
                if (!sourceElement) {
                    console.warn(`No element found in response for selector "${selector}".`);
                }
            }
            // setTimeout(() => {
              // console.log(shipping_modal_content);
            document.querySelector('.c-cart-template__shipping-container').innerHTML = shipping_modal_content;
            document.querySelector('.c-cart-template__shipping-container').innerHTML = cover_duties_modal_content;
            // }, 100);
            
        }
    })
  .catch((error) => {
    console.error('Error:', error);
  });
}


// free gift swatch
  document.addEventListener("click", function(e){
    let previousActiveElement = document.querySelector('span[data-var-swatch].active');

    const target = e.target.closest("span[data-var-swatch]");
    if (target){
      if (previousActiveElement !== target) {
        previousActiveElement.classList.remove('active');
      
        target.classList.add('active');
        
        const previousVarSwatch = previousActiveElement.getAttribute('data-var-swatch');
        const currentVarSwatch = target.getAttribute('data-var-swatch');


        let updates = {
          [parseInt(previousVarSwatch)]: 0,   
        };
        
        console.log("swatch",updates);
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates, sections: 'cart-drawer' })
        })
        .then(response => {
          freeGiftAdd('swatch','swatch2',parseInt(currentVarSwatch))
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });

        previousActiveElement = target;
        document.querySelector('cart-drawer').setAttribute('data-var-id',currentVarSwatch);
    }
    }
  });





















































